import { Editor } from 'slate';

export function handleEnter(editor) {
  const header = Editor.above(editor, { match(node) { return node.type === 'site-nav'; } });
  if (!header) {
    return false;
  }
  editor.insertText('\n');
  return true;
}
